(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-custom"] && !Shopify.designMode) return;
  try {
    

/* =========================================================
   PRODUCT IMAGE CAROUSELS
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  const carousels = document.querySelectorAll('[data-carousel]');

  carousels.forEach(function (carousel) {

    const slides = carousel.querySelectorAll('[data-slide]');
    const dots = carousel.querySelectorAll('[data-dot]');
    const prevButton = carousel.querySelector('[data-prev]');
    const nextButton = carousel.querySelector('[data-next]');

    if (!slides.length) {
      return;
    }

    let currentIndex = 0;


    /* -----------------------------------------
       SHOW SLIDE
       ----------------------------------------- */

    function showSlide(index) {

      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      currentIndex = index;


      slides.forEach(function (slide, i) {

        slide.classList.toggle(
          'is-active',
          i === currentIndex
        );

      });


      dots.forEach(function (dot, i) {

        dot.classList.toggle(
          'is-active',
          i === currentIndex
        );

      });

    }


    /* -----------------------------------------
       PREVIOUS
       ----------------------------------------- */

    if (prevButton) {

      prevButton.addEventListener('click', function (event) {

        event.preventDefault();
        event.stopPropagation();

        showSlide(currentIndex - 1);

      });

    }


    /* -----------------------------------------
       NEXT
       ----------------------------------------- */

    if (nextButton) {

      nextButton.addEventListener('click', function (event) {

        event.preventDefault();
        event.stopPropagation();

        showSlide(currentIndex + 1);

      });

    }


    /* -----------------------------------------
       DOTS
       ----------------------------------------- */

    dots.forEach(function (dot) {

      dot.addEventListener('click', function (event) {

        event.preventDefault();
        event.stopPropagation();

        const index = Number(
          dot.dataset.dot
        );

        showSlide(index);

      });

    });


    /* -----------------------------------------
       TOUCH / SWIPE
       ----------------------------------------- */

    let touchStartX = 0;
    let touchEndX = 0;


    carousel.addEventListener(
      'touchstart',
      function (event) {

        touchStartX =
          event.changedTouches[0].screenX;

      },
      { passive: true }
    );


    carousel.addEventListener(
      'touchend',
      function (event) {

        touchEndX =
          event.changedTouches[0].screenX;

        const difference =
          touchStartX - touchEndX;


        /* Swipe left */

        if (difference > 50) {

          showSlide(currentIndex + 1);

        }


        /* Swipe right */

        if (difference < -50) {

          showSlide(currentIndex - 1);

        }

      },
      { passive: true }
    );


  });


  /* =====================================================
     ADD TO CART
     ===================================================== */

  const cartButtons =
    document.querySelectorAll('.cart-btn');


  cartButtons.forEach(function (button) {

    button.addEventListener('click', function (event) {

      event.preventDefault();
      event.stopPropagation();


      const variantId =
        button.dataset.variantId;


      if (!variantId) {
        return;
      }


      const originalHTML =
        button.innerHTML;


      button.disabled = true;


      button.innerHTML = '✓';


      fetch('/cart/add.js', {

        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',
          'Accept':
            'application/json'
        },

        body: JSON.stringify({

          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]

        })

      })

      .then(function (response) {

        if (!response.ok) {
          throw new Error(
            'Unable to add product'
          );
        }

        return response.json();

      })

      .then(function () {

        setTimeout(function () {

          button.innerHTML =
            originalHTML;

          button.disabled = false;

        }, 1000);

      })

      .catch(function () {

        button.innerHTML =
          originalHTML;

        button.disabled = false;

      });

    });

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-exchange-popup"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const popup =
    document.getElementById('return-exchange-popup');

  if (!popup) return;


  /* =========================================
     OPEN POPUP
  ========================================= */

  function openPopup() {

    popup.classList.add('is-open');

    popup.setAttribute('aria-hidden', 'false');

    document.body.style.overflow = 'hidden';

  }


  /* =========================================
     CLOSE POPUP
  ========================================= */

  function closePopup() {

    popup.classList.remove('is-open');

    popup.setAttribute('aria-hidden', 'true');

    document.body.style.overflow = '';

  }


  /* =========================================
     OPEN WHEN CLICKING
     href="#return-exchange"
  ========================================= */

  document.addEventListener('click', function (event) {

    const trigger =
      event.target.closest(
        'a[href="#return-exchange"]'
      );


    if (trigger) {

      event.preventDefault();

      openPopup();

    }

  });


  /* =========================================
     CLOSE BUTTON + OVERLAY
  ========================================= */

  popup
    .querySelectorAll('[data-return-popup-close]')
    .forEach(function (element) {

      element.addEventListener(
        'click',
        closePopup
      );

    });


  /* =========================================
     ESC KEY
  ========================================= */

  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      popup.classList.contains('is-open')
    ) {

      closePopup();

    }

  });

});


  } catch(e) { console.error(e); }
})();
})();
